var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteProjectIlls(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 177,
    viewBox: "0 0 421 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.684 59.8255C330.669 64.1922 320.693 71.0425 310.84 77.5424C309.045 78.7264 307.25 79.9145 305.533 81.2088C304.988 81.6199 304.313 82.0058 304.071 82.6446C303.824 83.2998 305.326 83.2833 305.994 83.4907C311.363 85.1561 317.831 85.0804 323.301 84.0035C329.131 82.8557 334.264 79.2698 339.326 76.363C342.599 74.4831 344.757 72.7236 346.915 69.5942C347.848 68.2415 349.074 64.7417 347.799 63.1843C345.903 60.8663 341.554 59.1166 338.685 59.5948",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317 74.0447C320.427 73.8147 323.711 73.089 327.025 72.1986C327.716 72.013 329.246 71.8425 329.692 71.0449C329.911 70.6527 329.939 70.2764 329.922 69.8398C329.843 67.7724 321.929 70.0179 320.923 71.2756",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M310.994 87.2856C313.311 92.5517 315.602 97.8286 317.866 103.118C320.006 108.12 322.457 113.158 324.07 118.373C324.465 119.65 324.339 120.976 325.814 120.976C328.3 120.976 331 121.271 333.454 120.809C335.538 120.417 337.416 119.107 339.3 118.207C344.602 115.674 350.793 114.878 355.479 111.105C356.68 110.137 357.289 109.213 357.863 107.81C358.273 106.809 358.991 105.93 358.991 104.81C358.991 102.421 359.047 100.086 358.542 97.7336C357.742 94.0002 355.934 90.8377 354.068 87.5548C351.56 83.1396 348.549 79.1296 346.761 74.3633",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M324.147 92.5928C326.649 98.6697 328.907 104.775 330.839 111.053",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M334.3 87.7471C336.591 93.5732 338.794 99.4236 340.992 105.284",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M342.146 84.9775C343.952 89.3978 345.755 93.8398 347.799 98.1562C348.097 98.7833 348.089 98.881 348.607 99.0536",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M267.151 78.5167C270.409 79.443 271.806 80.2762 275.33 79.414C278.553 78.6252 281.986 76.3128 284.483 74.2605C288.7 70.7949 291.737 66.1484 296.021 62.7484C298.811 60.5334 302.672 58.034 306.456 58.7743C308.272 59.1296 309.743 60.6332 311.097 61.7741C312.557 63.0044 314 64.2557 315.455 65.4918C315.934 65.8986 316.415 66.2262 316.763 66.7482",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M311.686 68.1326C313.126 68.9229 315.732 70.5133 317.455 69.4658C319.212 68.3981 319.532 64.684 319.532 62.8252",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.744 23.2588C139.027 25.5874 139.332 27.9125 139.635 30.2385",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M136.219 17.17C134.152 18.4865 134.043 18.2952 132.49 20.7341C131.251 22.681 129.605 26.3311 128.827 28.5059C128.493 29.4417 127.755 31.5533 128.118 32.796C128.448 33.9291 130.197 34.9805 131.113 35.4856C133.511 36.8094 136.252 37.5616 138.934 38.0432C141.205 38.4511 144.282 39.1222 146.582 38.5052C151.124 37.2865 151.749 30.0887 149.808 26.6331C148.363 24.0611 145.844 22.0655 143.653 20.1483C141.68 18.4218 139.761 17.4001 137.111 17.0215",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M240.767 18.5068C240.928 20.7327 239.032 23.288 237.698 24.9256C237.557 25.0989 235.868 26.535 236.287 26.5179C240.207 26.3579 244.12 26.2291 248.044 26.2291",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M236.46 18.3579C236.603 16.7568 237.634 16.5144 238.985 16.5758C239.788 16.6123 240.025 17.021 240.025 17.7639",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M243.886 13.9031C238.447 12.1357 229.439 10.9837 226.213 17.1207C224.664 20.07 224.848 24.029 226.535 26.8808C229.152 31.3038 234.768 32.9596 239.529 33.4728C241.755 33.7127 244.025 33.7051 246.262 33.6543C248.624 33.6006 250.969 32.8547 252.548 31.0142C254.089 29.2189 254.194 26.5663 254.132 24.315C254.066 21.9058 252.341 19.4053 250.659 17.723C248.97 16.034 246.709 14.283 244.331 13.7546",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M149.217 1C127.317 11.1737 106.236 18.7942 82.1094 21.222C81.2639 21.3071 67.6829 22.4951 69.1095 24.0719C73.6847 29.1286 77.3927 32.9463 80.3136 39.336C83.5319 46.3759 86.7951 53.3849 88.785 60.8853C90.4714 67.2415 92.6687 73.7181 93.5478 80.2485C94.9628 90.7605 94.4066 101.604 94.4066 112.182C94.4066 122.059 93.5454 132.422 94.8751 142.242C96.0004 150.552 97.7636 158.189 97.9201 166.68C97.9268 167.046 98.2763 178.55 99.7159 175.191C101.869 170.167 103.567 166.839 108.07 163.44C118.33 155.697 128.957 152.055 141.604 150.011C154.035 148.002 165.578 147.161 178.184 147.161C185.282 147.161 192.401 147.319 199.499 147.161C201.375 147.119 200.514 143.466 200.514 142.242",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M149.918 1C152.657 10.4621 157.826 18.8873 161.63 27.9367C166.451 39.4076 170.15 51.2317 175.762 62.3688C179.46 69.7091 181.266 77.9174 184.584 85.4797C187.91 93.0574 189.409 101.88 191.338 109.918C192.519 114.84 192.498 119.734 193.836 124.675C194.629 127.602 195.498 130.922 196.647 133.732C197.553 135.946 198.857 137.835 200.122 139.822C200.409 140.273 200.731 141.254 200.434 141.774C199.871 142.759 196.395 136.769 196.296 136.62",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.892 44.5672C169.713 33.5465 169.376 22.0606 168.541 11.033C168.47 10.0928 167.296 4.71851 168.814 4.12312C169.685 3.78169 173.03 3.81396 173.343 3.81081C179.028 3.75368 184.717 3.81081 190.402 3.81081C204.378 3.81081 218.354 3.81081 232.33 3.81081C239.039 3.81081 246.113 3.251 252.825 3.96697C258.789 4.60307 259.421 5.54437 260.087 11.6966C260.627 16.6956 262.131 21.3859 262.702 26.4142C263.486 33.3145 263.053 40.4086 263.053 47.3389C263.053 67.6651 263.053 87.9912 263.053 108.317C263.053 116.242 263.053 124.167 263.053 132.092C263.053 133.606 262.46 136.409 263.444 137.674C265.164 139.886 264.928 143.92 265.318 146.536C265.407 147.133 267.396 153.582 265.083 152.041C260.483 148.974 253.876 147.579 248.609 146.068C241.17 143.933 234.529 143.647 226.826 143.647C219.616 143.647 212.407 143.647 205.198 143.647C201.952 143.647 197.806 144.402 194.892 142.945",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.432 48.7833C101.699 52.8733 103.011 60.7291 108.068 60.7291C109.529 60.7291 113.378 60.8222 113.378 58.8943C113.378 54.525 111.843 50.6273 110.567 46.48C109.995 44.6229 100.421 47.9053 99.3237 48.7833",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.352 81.8101C123.755 76.8568 140.664 72.9824 158.664 71.1135C161.131 70.8574 164.341 70.8416 166.784 69.8643",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.055 99.3782C112.074 99.3782 117.204 98.4106 121.812 96.5674",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M121.108 137.323C134.459 133.132 147.256 132.404 161.162 132.404",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M180.837 25.5942C180.837 30.7473 180.837 35.9004 180.837 41.0536C180.837 41.818 180.404 44.7595 181.227 45.582C182.433 46.7878 186.681 45.9724 188.215 45.9724C189.064 45.9724 193.106 46.6066 193.797 45.8163C195.607 43.7477 193.452 36.7295 193.173 34.5341C192.676 30.628 193.493 25.9148 190.518 22.9396C189.517 21.9389 184.051 23.6355 182.945 24.1888",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M179.432 67.0537H246.891",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M183.648 80.4043C190.677 80.8498 197.702 81.3306 204.729 81.8097",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M193.485 119.053C209.52 119.053 227.164 117.08 242.674 121.161",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1 159.514C12.1236 156.91 22.0461 150.842 33.2393 148.305C42.3758 146.234 53.207 146.101 62.1493 148.86C69.7083 151.192 77.4557 154.845 85.2884 156.129C89.5992 156.835 94.0195 156.517 98.3838 156.517",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M420 149.526C399.73 144.276 379.055 136.459 357.963 135.653C347.267 135.245 335.779 134.581 325.169 136.097C319.869 136.854 314.885 139.384 309.632 139.926C303.566 140.551 297.369 139.432 291.32 140.314C283.381 141.472 275.728 141.535 267.682 141.535",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteProjectIlls);
export default __webpack_public_path__ + "static/media/deleteProjectIlls.f16f93f17f9464cf1f2f71645eec2ebb.svg";
export { ForwardRef as ReactComponent };